import { useCopyToClipboard } from 'react-use';
import { useUserContext } from '../../../contexts/UserContext';
import useCurrentOrganizationInfo from '../../../hooks/useCurrentOrganizationInfo';
// import ShareButton from '../../NewProductUI/ShareButton';
import { useInfoDialogaActions } from '../../../hooks/useInfoDialogaActions';
import { useEffect, useState } from 'react';
import { successToast } from '../../../helpers/toastHelper';
import {
  AddAddonCart,
  createProductVideoPublicData,
  createTextureVideoPublicDataV2,
  GetAllCartProductList,
  getProductVideoPublicData,
  getSubscriptionLinkedProductData,
  getTextureVideoPublicData,
  linkSubscriptionProductData,
  removeAllItemsFromCart,
  setClientSubscriptionPlans,
} from '../../../api/subscription/subscription';
import { ADMIN_SETTINGS, SIGN_IN_ROUTE, SIGNUP_ROUTE } from '../../../constants/routePathConstants';
import { useDispatch, useSelector } from 'react-redux';
import {
  selectAddonsList,
  selectAvailable3DViewer,
  selectAvailable3DViewerAR,
  selectAvailableAIVideo,
  selectAvailableConfigurator,
  selectAvailableVideo,
  selectUserActivePlanDetails,
  selectUserPlanList,
} from '../../../redux/slicers/subscriptionSlicer';
import {
  LINKED_PRODUCT_DATA,
  navigateToUpgradePlan,
  OFFER_PRICE_DATA,
} from '../../subscriptionComponents/subscriptionHelper';
import {
  embedCopy360Viewer,
  embedCopy3DViewer,
  embedCopyAIVideo,
  embedCopyArViewer,
  embedCopyConfigurator,
  embedCopyVideo,
} from './helpers';
import { PRODUCT_CATEGORY, SETTINGS_TAB } from '../../../constants/constants';
import styles from '../../../components/InfoDialog/InfoDialogUI.module.scss';
import productStyles from '../styles.module.scss';
import {
  isIphoneIOS,
  openFormInCaseOfNewOrgAndFreemiumUser,
  windowOpen,
} from '../../../helpers/jsHelper';
import { navigate } from '../../../helpers/projectHelper';
import {
  apiGetWebExperienceProductDetails,
  apiGetWebExperienceTextureDetails,
} from '../../../helpers/api';
import { CopyEmbedLink, ShareProductIcon } from '../../../assets/icons';
import Switch from '../../../components/admin/switch';

const { THREEDVIEWER, ARVIEWER, THREESIXTY, VIDEO, CONFIGURATOR } = PRODUCT_CATEGORY;

export const ALLOWED_SHARED_CATEGORIES = [THREEDVIEWER, ARVIEWER, THREESIXTY, VIDEO, CONFIGURATOR];

const SHARE_3D_VIEWER = {
  // TODO: update the info here when the API development is done
  status: 'product_3d_viewer_status',
  countSelector: selectAvailable3DViewer,
  baseModelKey: '3D Viewer',
  type: LINKED_PRODUCT_DATA.THREED_VIEWER,
  embedCopyFunction: embedCopy3DViewer,
  title: '3D Viewer',
  description:
    'This will disable the public link or embedded link you used. Are you sure you want to continue?',
};

const SHARE_AR_VIEWER = {
  status: 'product_viewer_status',
  countSelector: selectAvailable3DViewerAR,
  baseModelKey: '3D_Viewer',
  type: LINKED_PRODUCT_DATA.PRODUCT_VIEWER,
  embedCopyFunction: embedCopyArViewer,
  title: 'AR Viewer',
  description:
    'Disabling AR viewer will also disable 360° viewer. This will disable the public link or embedded link you used. Are you sure you want to continue?',
};

const SHARE_AI_VIDEO = {
  status: 'ai_video_v2_status',
  countSelector: selectAvailableAIVideo,
  baseModelKey: 'AIVideo',
  type: LINKED_PRODUCT_DATA.AI_VIDEO,
  embedCopyFunction: embedCopyAIVideo,
  isVideo: true,
};

const SHARE_MAPPING = {
  [THREEDVIEWER]: SHARE_3D_VIEWER,
  [ARVIEWER]: SHARE_AR_VIEWER,
  [THREESIXTY]: {
    ...SHARE_AR_VIEWER,
    embedCopyFunction: embedCopy360Viewer,
    title: '360° Viewer',
    description:
      'Disabling 360° viewer will also disable AR viewer. This will disable the public link or embedded link you used. Are you sure you want to continue?',
  },
  [VIDEO]: {
    status: 'video_status',
    countSelector: selectAvailableVideo,
    baseModelKey: 'Video',
    type: LINKED_PRODUCT_DATA.VIDEO,
    embedCopyFunction: embedCopyVideo,
    isVideo: true,
  },
  [CONFIGURATOR]: {
    status: 'configurator_status',
    countSelector: selectAvailableConfigurator,
    baseModelKey: 'Configurator',
    type: LINKED_PRODUCT_DATA.CONFIGURATOR,
    embedCopyFunction: embedCopyConfigurator,
    title: 'Product Configurator',
    description:
      'Are you sure you want to disable product configurator? This will disable the public link or embedded link you used.',
    isConfigurator: true,
  },
};

export const ShareModalButton = ({
  isPublicPage,
  productInfo,
  productId,
  productUnicodeId,
  orgProductUniqueCodeId,
  category,
  selectedItem,
  isPackProduct,
  currentOrg,
  isTexture,
  onToggle,
  checked,
  disabled,
  videoObjectId = null,
  refreshPage = 0,
  setRefreshPage = () => {},
  configuratorUniqueId = null
}) => {
  const dispatch = useDispatch();
  const aiVideoId = selectedItem?.aivideo;
  const videoId = selectedItem?.video;
  const shareObj = aiVideoId ? SHARE_AI_VIDEO : SHARE_MAPPING[category];
  const isVideo = Boolean(shareObj?.isVideo);
  const { currentUser, isOldSubscriptionUser, isPremiumUser, isGuestUser, isGuestLogin } =
    useUserContext();
  const { isFreemiumUser, isFreemiumOrSelfServeUser, hideNewPlans } = useCurrentOrganizationInfo();
  const [state, copy] = useCopyToClipboard();
  const { openInfoDialog, closeInfoDialog } = useInfoDialogaActions();
  const activePlan = useSelector(selectUserActivePlanDetails) || isOldSubscriptionUser();
  const availableCount = useSelector(shareObj.countSelector);
  const getUserPlans = useSelector(selectUserPlanList);
  const isOldPremiumUser = isPremiumUser() && getUserPlans?.length === 0;
  const { results: addonsList } = useSelector(selectAddonsList);
  const [actionMenu, setActionMenu] = useState([]);
  const [allStatus, setAllStatus] = useState(null);
  const status = allStatus?.[shareObj?.status];
  const baseModelKey = shareObj.baseModelKey;
  const [configuratorUrl, setConfiguratorUrl] = useState('');
  const [enableDisableStatus, setEnableDisableStatus] = useState(false);
  const [loader, setLoader] = useState(false);
  const [videoUnicode, setVideoUnicode] = useState(null);
  
  useEffect(() => {
    if (isIphoneIOS() && (videoId || aiVideoId)) {
      getVideoUnicodeInIos();
    }
  }, [videoId, aiVideoId]);

  useEffect(() => {
    if (productInfo?.id && selectedItem?.id) getStatus();
  }, [productInfo?.id, selectedItem]);

  useEffect(() => {
    if (shareObj.type === LINKED_PRODUCT_DATA?.PRODUCT_VIEWER && productInfo?.id && selectedItem?.id && refreshPage > 0) getStatus();
  }, [refreshPage]);


  useEffect(() => {
    let statusClone = status;
    if (isVideo) {
      const id = aiVideoId || videoId;
      const isVideoActive = Array.isArray(status)
        ? status?.find((a) => parseInt(a?.object_id) === parseInt(id))
        : status;
      statusClone = Boolean(isVideoActive);
    }
    setEnableDisableStatus(statusClone);
  }, [selectedItem, shareObj, status]);

  useEffect(() => {
    const actions = [
      {
        id: 1,
        title: isVideo ? 'Use this video' : 'Disabled',
        icon: null,
        onClick: handleEnabledDisabled,
        type: isVideo ? 'button' : 'toggle',
        initialValue: enableDisableStatus,
        loading: false,
      },
      { id: 2, title: 'Copy Link', icon: null, onClick: handleCopyEmbedding, disabled: true },
      {
        id: 3,
        title: 'Embed on website',
        icon: null,
        onClick: () => handleCopyEmbedding(true),
        disabled: true,
      },
      isVideo && {
        id: 5,
        title: 'Note: Once you use this video, it will be deducted from your package.',
        type: 'info',
      },
    ].filter((val) => Boolean(val));
    setActionMenu(actions);
  }, [
    productUnicodeId,
    orgProductUniqueCodeId,
    enableDisableStatus,
    configuratorUrl,
    selectedItem,
    loader,
    videoUnicode,
  ]);

  useEffect(() => {
    setActionMenu((prev) => [
      ...prev
        .map((a) => {
          if (a.id === 1 && isVideo && enableDisableStatus) return null;
          if (a.id === 1 && !isPackProduct) {
            return {
              ...a,
              title: isVideo ? 'Use this video' : enableDisableStatus ? 'Enabled' : 'Disabled',
              initialValue: enableDisableStatus,
            };
          }
          if (a.id === 1 && isPackProduct) return null;
          return {
            ...a,
            disabled: isPackProduct ? false : enableDisableStatus ? false : true,
          };
        })
        .filter(Boolean),
    ]);
  }, [
    productUnicodeId,
    orgProductUniqueCodeId,
    enableDisableStatus,
    isPackProduct,
    configuratorUrl,
    selectedItem,
    loader,
    videoUnicode,
  ]);

  useEffect(async () => {
    if (!productUnicodeId || !shareObj?.isConfigurator || (isPublicPage && !currentUser)) return;
    const res = await getSubscriptionLinkedProductData({
      type: LINKED_PRODUCT_DATA.CONFIGURATOR,
      isPublicPage: isPublicPage && !currentUser,
      params: {
        [isTexture ? 'texture_uuid' : 'product_uuid']: productUnicodeId,
        [isTexture ? 'texture_org' : 'product_org']: currentOrg || currentUser?.organization,
        is_preview: Boolean(isPublicPage && !currentUser),
        // configurator_id: selectedItem?.configurator_details?.configurator_id  // TO DO: Need to add this in future to get configurator
      },
      isTexture,
    });
    if (res && res?.results?.length > 0) {
      const data = res?.results.find(
        (val) => parseInt(val?.id) === parseInt(selectedItem?.configurator)
      );
      // const url = data?.url?.split('/')?.pop();
      // For V2, we should use unique_id of configurator
      const unique_id = data?.unique_id;
      setConfiguratorUrl(configuratorUniqueId || unique_id || res?.results?.[0]?.unique_id);
    }
  }, [productUnicodeId, selectedItem]);

  const getVideoUnicodeInIos = async () => {
    const videoUnicode = await getVideoUniqueCode();
    setVideoUnicode(videoUnicode);
  };

  const getStatus = async () => {
    if (isPublicPage && !currentUser) return;
    const getFunc = isTexture
      ? apiGetWebExperienceTextureDetails
      : apiGetWebExperienceProductDetails;
    const res = await getFunc({ id: productInfo?.id });
    if (res?.id) {
      const statusObj = {
        configurator_status: res?.configurator_status,
        product_viewer_status: res?.product_viewer_status,
        video_status: res?.video_status,
        ai_video_v2_status: res?.ai_video_v2_status,
        product_3d_viewer_status: res?.product_3d_viewer_status,
      };
      setAllStatus(statusObj);
    }
  };

  async function getVideoUniqueCode() {
    if (isPublicPage && !currentUser) return;
    let productUniqueCode = null;
    const getFunc = isTexture ? getTextureVideoPublicData : getProductVideoPublicData;
    const response = await getFunc(
      `${isTexture ? 'texture' : 'product'}=${productInfo?.id}&model_obj_id=${aiVideoId || videoId}`
    );
    const id = aiVideoId || videoId;
    const results = response?.results?.filter(
      (val) => parseInt(val?.model_obj_id) === parseInt(id)
    );
    if (results?.length > 0) {
      productUniqueCode = results?.[0]?.unique_code;
    } else {
      const formData = new FormData();
      formData.append(isTexture ? 'texture' : 'product', productInfo?.id);
      formData.append('model_obj_id', aiVideoId || videoId);
      const createFunc = isTexture ? createTextureVideoPublicDataV2 : createProductVideoPublicData;
      const res = await createFunc(formData);
      if (res?.status) {
        productUniqueCode = res?.data?.unique_code;
      }
    }
    return productUniqueCode;
  }

  async function doEnableDisable(toggleValue) {
    if ((isVideo && enableDisableStatus) || loader) return;
    setLoader(true);
    if (isVideo) {
      setActionMenu((prev) => [
        ...prev.map((a) => {
          if (a.id === 1) {
            return {
              ...a,
              loading: true,
            };
          }
          return a;
        }),
      ]);
    }
    const formData = new FormData();
    formData.append('type', shareObj.type);
    formData.append('is_link', isVideo ? true : toggleValue);
    formData.append(isTexture ? 'texture_id' : 'product_id', productInfo?.id);
    if (isVideo) {
      formData.append('model_obj_id', aiVideoId || videoId || videoObjectId);
    }
    const res = await linkSubscriptionProductData(formData);
    if (res?.status) {
      setEnableDisableStatus(!enableDisableStatus);
      successToast(res?.message);
    } else {
      toggleValue = false;
    }
    const callback = () => {
      setLoader(false);
    };
    dispatch(setClientSubscriptionPlans(false, undefined, callback));
    getStatus();
    if(shareObj.type === LINKED_PRODUCT_DATA?.PRODUCT_VIEWER){
      setRefreshPage(+refreshPage + 1)
    }
    const updatedMenu = actionMenu.map((a) => {
      if (a.id === 1) {
        if (isVideo) {
          return {
            ...a,
            loading: false,
          };
        }
        return {
          ...a,
          title: toggleValue ? 'Enabled' : 'Disabled',
          initialValue: toggleValue,
        };
      }
      return !isVideo
        ? {
            ...a,
            disabled: !toggleValue,
          }
        : a;
    });
    setActionMenu(updatedMenu);
  }

  function openModelWhileDisabling(toggleValue) {
    openInfoDialog({
      title: shareObj.title,
      description: shareObj.description,
      buttonText: 'Yes',
      onButtonClick: () => doEnableDisable(toggleValue),
      cancelButtonText: 'No',
      dialogClassName: styles.viewerModal,
      designV2: true,
      btnContainerClass: 'justify-content-end',
      designV2Props: {
        fillBtnClassName: styles.viewerBtn,
        cancelBtnClassName: styles.cancelBtn,
      },
    });
  }

  function handleEnabledDisabled(item) {
    if (loader) return;
    if (!isVideo) item.e.stopPropagation();
    let toggleValue = item.value;
    if (toggleValue || isVideo) doEnableDisable(toggleValue);
    else openModelWhileDisabling(toggleValue);
  }

  async function handleCopyEmbedding(flag = false) {
    let unicode = orgProductUniqueCodeId;
    if (isVideo) {
      unicode = videoUnicode || (await getVideoUniqueCode());
    }
    shareObj.embedCopyFunction({
      productInfo,
      configuratorUrl,
      orgProductUniqueCodeId: unicode,
      copy,
      isTexture,
      isIframe: flag,
    });
  }

  const buyFunc = async () => {
    await dispatch(GetAllCartProductList());
    const addonsItem = addonsList?.find(
      ({ basemodeltype }) => basemodeltype === OFFER_PRICE_DATA[baseModelKey].baseModelType
    );
    let payload = {
      subscription_price: addonsItem?.id || OFFER_PRICE_DATA[baseModelKey].product_id,
      quantity: 1,
    };
    await removeAllItemsFromCart();
    const response = await AddAddonCart(payload, 'add');
    if (response?.status) {
      closeInfoDialog();
      let tab = SETTINGS_TAB.ADD_ONS;
      if (isFreemiumOrSelfServeUser) {
        tab = SETTINGS_TAB.PLANS;
      }
      const url = `${ADMIN_SETTINGS}?activeTab=${tab}&checkout=true&is_one_time=${isVideo}&ignoreIsSendPrice=true&referrer=${window.location.href}`;
      windowOpen(url, '_blank');
    }
  };

  const handleShareForUse = () => {
    if (loader) return;
    if (hideNewPlans) {
      // open enterprise form in case of freemium user whose org is created after 10th Feb 2025
      openFormInCaseOfNewOrgAndFreemiumUser();
      return;
    }
    let title = 'Add item';
    let description = '';
    let buttonText = '';
    let buttonText2 = '';
    let onButtonClick = null;
    let onButtonClick2 = null;
    if (isOldPremiumUser && availableCount === 0) {
      title = 'Buy add on';
      buttonText = 'Buy';
      description = 'This item will be added on top of your existing subscription (if any).';
      onButtonClick = buyFunc;
    } else if (!activePlan && availableCount === 0) {
      buttonText = 'View plans';
      description =
        'You currently do not have an active subscription. Please purchase a subscription plan or buy this item separately.';
      onButtonClick = () =>
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      buttonText2 = 'Buy item';
      onButtonClick2 = buyFunc;
    } else if (availableCount === 0) {
      buttonText = 'Upgrade plan';
      description =
        'You do not have this item. Please upgrade your subscription plan or buy this item separately.';
      onButtonClick = () =>
        navigateToUpgradePlan({ browsePlan: true, newTab: true, referrer: window.location.href });
      buttonText2 = 'Buy item';
      onButtonClick2 = buyFunc;
    } else {
      return null;
    }

    openInfoDialog({
      title: title,
      description: description,
      buttonText: buttonText,
      onButtonClick: onButtonClick,
      buttonText2: buttonText2,
      onButtonClick2: onButtonClick2,
      addOrSeparator: false,
      btnContainerClass: 'align-items-center',
      backdropClassName:styles.inviteModal,
      closeable: false,
      designV2: true,
      designV2Props: {
        fillBtnClassName: styles.fillBtn,
        okBtnClassName: styles.btnLink,
      },
    });
  };

  const handleClick = (e) => {
    const makeCall = () => {
        actionMenu?.[0]?.onClick({e:e , value:actionMenu?.[0]?.initialValue || enableDisableStatus ? false : true, item:null})
        onToggle(e,category)
    }
     isPublicPage && !currentUser
      ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
      : enableDisableStatus
      ? makeCall()
      : (!activePlan && availableCount === 0) || availableCount === 0
      ? isPackProduct
        ? makeCall()
        : handleShareForUse()
      : makeCall()      
  }

  return (
    <>
      {/* {isGuestUser() || isGuestLogin ? null : ( */}
        <>
          <div className={styles.copyLinkSwitch}>
            {(actionMenu?.[0]?.initialValue || enableDisableStatus) && !disabled && (
              <span onClick={actionMenu?.[videoObjectId ? 1 : 2]?.onClick}>
                {' '}
                <CopyEmbedLink />
              </span>
            )}
            {videoObjectId && enableDisableStatus ? null : (
              <Switch
                disabled={disabled}
                checked={disabled ? false : actionMenu?.[0]?.initialValue || enableDisableStatus || false}
                onToggle={(e) => !disabled && handleClick(e)}
                containerClassName={disabled ? "disabled-toggle" : ""}
              />
            )}
          </div>
          {/* <ShareButton
            className={`${productStyles.btn} ${productStyles.dark}`}
            menuClassName="me-auto"
            itemClassName="bg-white"
            icon={<ShareProductIcon />}
            onClick={
              isPublicPage && !currentUser
                ? () => navigate(SIGN_IN_ROUTE) // SIGNUP_ROUTE // Commenting this code to prevent signup
                : enableDisableStatus
                ? null
                : (!activePlan && availableCount === 0) || availableCount === 0
                ? isPackProduct
                  ? null
                  : handleShareForUse
                : null
            }
            menu={actionMenu}
          /> */}
        </>
      {/* )} */}
    </>
  );
};
